var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7329 3.99921C4.04901 3.97041 6.27595 3.10197 8.0001 1.55521C9.72413 3.10226 11.9511 3.97099 14.2673 4.00001C14.3553 4.52001 14.4001 5.05601 14.4001 5.60081C14.4001 9.78081 11.7281 13.3368 8.0001 14.6544C4.2721 13.336 1.6001 9.78001 1.6001 5.60001C1.6001 5.05441 1.6457 4.52001 1.7329 3.99921ZM10.9657 6.96561C11.1114 6.81472 11.1921 6.61264 11.1902 6.40289C11.1884 6.19313 11.1043 5.99248 10.956 5.84415C10.8076 5.69583 10.607 5.61169 10.3972 5.60987C10.1875 5.60804 9.98538 5.68868 9.8345 5.83441L7.2001 8.46881L6.1657 7.43441C6.01482 7.28868 5.81273 7.20804 5.60298 7.20987C5.39322 7.21169 5.19257 7.29583 5.04424 7.44415C4.89592 7.59248 4.81178 7.79313 4.80996 8.00289C4.80814 8.21264 4.88877 8.41472 5.0345 8.56561L6.6345 10.1656C6.78452 10.3156 6.98797 10.3998 7.2001 10.3998C7.41223 10.3998 7.61568 10.3156 7.7657 10.1656L10.9657 6.96561Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/ShieldCheck.e3aa17cc99e25b747fa30b4f25fe1318.svg";
export { ForwardRef as ReactComponent };